import React from 'react';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import moment from 'moment';

import { withTheme } from '@material-ui/core/styles';

import { paramConverter } from 'modules/common';
import { getFormat, twoDigits } from 'lib/commonLib';
import { mediaFluctuationStatisticsGraph } from 'lib/api/media';

import CurrentStatus from 'components/atoms/CurrentStatus';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import CustomActiveShapePieChart from 'components/organisms/Chart/CustomActiveShapePieChart';

const graphList = [
  {
    keyName: 'ADVRTS_AMT',
    title: i18next.t('지출금액'),
  },
  {
    keyName: 'PAR_EPRS_CNT',
    title: i18next.t('노출'),
  },
  {
    keyName: 'REQ_CNT',
    title: i18next.t('요청수'),
  },
  {
    keyName: 'CLICK_RATE',
    title: 'CTR',
  },
];

class MediaFluctuationStatisticsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      circleDatas: [],
      infoMessage: '',
      loading: false,
      error: false,
    };
  }

  getData = () => {
    const { params, locale, t } = this.props;
    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });

    mediaFluctuationStatisticsGraph({
      ...paramConverter(params),
    })
      .then((response) => {
        const { data } = response.data;

        this.setState({
          ...this.state,
          circleDatas: data,
          loading: false,
          error: false,
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          loading: false,
          error: true,
        });
      });
  };

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { params: prevParams } = prevProps;
    const { params } = this.props;

    if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
      this.getData();
    }
  }

  /**
   * 새로고침
   */
  handleRefesh = () => {
    this.getData();
  };

  // 월 일 or 일 반환
  makeLabel = (onlyDay) => (originalDate) => {
    const { t, theme } = this.props;
    const dateObj = moment(originalDate, 'YYYYMMDD');
    const month = twoDigits(dateObj.month() + 1);
    const date = dateObj.date();
    const day = dateObj.day();
    let color = '';

    if (day === 0) {
      color = theme.palette.common.red;
    } else if (day === 6) {
      color = theme.palette.common.blue;
    }

    return onlyDay ? (
      `${twoDigits(date)}${t('일')}`
    ) : (
      <span style={{ color }}>{`${t(month + '월')} ${twoDigits(date)}${t(
        '일'
      )}`}</span>
    );
  };

  xAxisTick = (tickProps) => {
    const { theme } = this.props;
    const { x, y, payload } = tickProps;
    const { value } = payload;
    const dateObj = moment(value, 'YYYYMMDD');
    const day = dateObj.day();

    const dayStr = this.makeLabel(true)(value);
    let fill = '';
    //Sunday as 0 and Saturday as 6.
    if (day === 0) {
      fill = theme.palette.common.red;
    } else if (day === 6) {
      fill = theme.palette.common.blue;
    }

    return (
      <text x={x} y={y + 10} fill={fill} textAnchor="middle">
        {dayStr}
      </text>
    );
  };

  render() {
    const { handleRefesh } = this;
    const { t } = this.props;
    const { infoMessage, circleDatas, loading, error } = this.state;

    return (
      <SwitchingArea
        title={
          <>
            <InfoTitleArea
              title={t('매체 등락 그래프')}
              tooltipTitle={infoMessage}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
      >
        {loading || error ? (
          <CurrentStatus type={loading ? 'loading' : error && 'error'} />
        ) : (
          <ContentsWrap contentsCount={2}>
            {graphList.map((item, index) => {
              if (circleDatas.length === 0) return '';
              return (
                <CustomActiveShapePieChart
                  key={index}
                  width={350}
                  height={300}
                  title={t(item.title)}
                  data={circleDatas[item.keyName].data}
                  total={circleDatas[item.keyName].total}
                  cxSubtractVal={20}
                  cySubtractVal={20}
                  innerRadius={70}
                  outerRadius={100}
                  dataKey="value"
                  legend
                />
              );
            })}
          </ContentsWrap>
        )}
      </SwitchingArea>
    );
  }
}

export default withTranslation()(
  connect(
    ({ locale }) => ({
      locale: locale.locale,
    }),
    null
  )(withTheme(MediaFluctuationStatisticsGraph))
);
